import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { getIdMap } from '../helpers/helpers';
import Labels from '../labels/Labels';

function ProjectLabels({
  projectId,
  size,
}) {
  const projectToLabel = useSelector((state) => state.projects.projectToLabel);
  const labels = useSelector((state) => state.labels);
  const projectLabels = useMemo(() => labels.filter((label) => label.type === 'projects'), [
    labels,
  ]);

  const labelIdMap = useMemo(() => getIdMap(projectLabels), [projectLabels]);

  const ourFilteredLabels = useMemo(() => {
    const {
      [projectId]: ourLabels = [],
    } = projectToLabel;
    return ourLabels.map((labelId) => labelIdMap[labelId]).filter((label) => label);
  }, [projectToLabel, labelIdMap, projectId]);

  return (
    <Labels
      id={projectId}
      size={size}
      labels={ourFilteredLabels}
    />
  );
}

ProjectLabels.propTypes = {
  projectId: PropTypes.string.isRequired,
  size: PropTypes.string,
};

ProjectLabels.defaultProps = {
  size: null,
};

export default ProjectLabels;
